import { RiskAssessmentItem, SafetyPrecautionsChecklist } from './types';

// 風險評估項目初始數據
export const INITIAL_RISK_ASSESSMENT_ITEMS: RiskAssessmentItem[] = [
    {
        itemId: '1.1',
        assessmentContent: '本工作屬於《工廠及工業經營(密閉空間)規例》第3條所述的在密閉空間內或在緊接密閉空間的附近地方進行,並與在密閉空間內進行的工作有關連工作。',
        assessmentItems: '',
        assessmentResult: { yes: false, no: false, reason: '' },
        workMethods: '',
        industrialEquipment: '',
        materials: '',
        nonEntryMeasures: '',
        isSafetyPrecautions: false,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.2',
        assessmentContent: '',
        assessmentItems: '本密閉空間工作是否屬於《工廠及工業經營(密閉空間)規例》第9(b) 條所述的地底喉管工作?',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [
            {
                item: 'confirmWearAppropriateBreathingApparatusAndSafetyLanyard',
                content: '須確保任何進入該密閉空間或在其內逗留的人已妥當地(i)配戴適當的認可呼吸器具;及(ii)配戴適當並與救生繩連接的安全吊帶。',
                isChecked: false
            },
            {
                item: 'continuousMonitoringOfAirInTheEnclosedSpace',
                content: '須對密閉空間內的空氣作連續性的監測,直到所有人離開該密閉空間為止。',
                isChecked: false
            }
        ],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.3',
        assessmentContent: '',
        assessmentItems: '本密閉空間內是否有具危害性的氣體、蒸氣、塵埃或煙氣存在或有貧氧情況?',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [
            {
                item: 'confirmWearAppropriateBreathingApparatusAndSafetyLanyard',
                content: '須確保任何進入該密閉空間或在其內逗留的人已妥當地(i)配戴適當的認可呼吸器具;及(ii)配戴適當並與救生繩連接的安全吊帶。',
                isChecked: false
            },
            {
                item: 'continuousMonitoringOfAirInTheEnclosedSpace',
                content: '須對密閉空間內的空氣作連續性的監測,直到所有人離開該密閉空間為止。',
                isChecked: false
            }
        ],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.4',
        assessmentContent: '',
        assessmentItems: '密閉空間內具危害性的氣體、蒸氣、塵埃或煙氣的進入',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.5',
        assessmentContent: '',
        assessmentItems: '密閉空間內是否有可散發具危害性的氣體、蒸氣、塵埃或煙氣的淤泥或其他沉積物存在?',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [
            {
                item: 'confirmWearAppropriateBreathingApparatusAndSafetyLanyard',
                content: '須確保任何進入該密閉空間或在其內逗留的人已妥當地(i)配戴適當的認可呼吸器具;及(ii)配戴適當並與救生繩連接的安全吊帶。',
                isChecked: false
            },
            {
                item: 'continuousMonitoringOfAirInTheEnclosedSpace',
                content: '須對密閉空間內的空氣作連續性的監測,直到所有人離開該密閉空間為止。',
                isChecked: false
            }
        ],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.6',
        assessmentContent: '',
        assessmentItems: '密閉空間內有自由流動的固體或液體的湧入',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.7',
        assessmentContent: '',
        assessmentItems: '密閉空間內發生火警或爆炸',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.8',
        assessmentContent: '',
        assessmentItems: '密閉空間內存在可引致核准工人因體溫上升而喪失知覺的環境溫度',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.9',
        assessmentContent: '',
        assessmentItems: '在密閉空間內進行工作的過程中,出現環境改變增加上述危害的危險性',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.10',
        assessmentContent: '',
        assessmentItems: '在密閉空間內或其附近進行工作的過程中,發生工人從高處墮下的危險性',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.11',
        assessmentContent: '',
        assessmentItems: '其他(請詳細列出)',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.12',
        assessmentContent: '',
        assessmentItems: '其他(請詳細列出)',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: true,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
    },
    {
        itemId: '1.13',
        assessmentContent: '',
        assessmentItems: '核准工人可在本密閉空間內安全地逗留的時限',
        assessmentResult: { yes: false, no: false, reason: '' },
        isSafetyPrecautions: false,
        defaultSafetyPrecautions: [],
        extraSafetyPrecautions: [],
        severity: 0,
        likelihood: 0,
        riskRating: 0,
        stayHour: 0
    }
];

// 安全預防措施清單初始數據
export const INITIAL_SAFETY_PRECAUTIONS_CHECKLIST: SafetyPrecautionsChecklist = {
    item1: false,
    item2: false,
    item3: false,
    item4: false,
    item5: false,
    item6: false,
    item7: {
        main: false,
        oxygen: false,
        explosiveLimit: false,
        hydrogenSulfide: false,
        carbonMonoxide: false,
        other: false,
        otherText: ''
    },
    item8: false,
    item9: false,
    item10: false,
    item11: false,
    item12: false,
    item13: false,
    item14: false,
    item15: false,
    item16: false,
    item17: {
        main: false,
        other: ''
    }
};

// 項目配置
export const ITEM_CONFIG = {
    SPECIAL_ITEMS: ['1.1'], // 需要特殊顯示的項目
    YES_NO_ITEMS: ['1.2', '1.3', '1.5'], // 需要是/否選擇的項目
    OTHER_ITEMS: ['1.11', '1.12'], // 其他項目
    HOUR_ITEMS: ['1.13'], // 需要小時數輸入的項目
    NO_RISK_RATING_ITEMS: ['1.1', '1.2', '1.3', '1.5', '1.13'] // 不需要風險評級的項目
} as const;

// 風險等級配置
export const RISK_LEVEL_CONFIG = {
    HIGH: { min: 6, color: '#ffcdd2', label: '高危險性' },
    MEDIUM: { min: 3, max: 5, color: '#fff3e0', label: '中危險性' },
    LOW: { max: 2, color: '#e8f5e8', label: '低危險性' }
} as const;